import { Platform } from "react-native";
import { useEffect } from "react";
import messaging from "@react-native-firebase/messaging";
import { PermissionsAndroid } from "react-native";
import notifee, { EventType } from "@notifee/react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { globalImport } from "./globalImports";

//import PushNotification from 'react-native-push-notification';

const useNotification = (initializeListener = true) => {
  let notificationListener = null;
  let notificationBackgroundListener = null;
  let foregroundListener = null;
  let channelId = "";

  useEffect(() => {
    return notifee.onForegroundEvent(({ type, detail }) => {
      switch (type) {
        case EventType.DISMISSED:
          console.log("User dismissed notification", detail.notification);
          break;
        case EventType.PRESS:
          console.log("User pressed notification", detail.notification);
          break;
      }
    });
  }, []);

  const removeListners = () => {
    if (notificationListener) {
      notificationListener();
    }
    if (notificationBackgroundListener) {
      notificationBackgroundListener();
    }
    if (foregroundListener) {
      foregroundListener();
    }
  };

  const requestUserPermission = async () => {
    if (Platform.OS === "android" && Platform.Version > 32) {
      try {
        const granted = PermissionsAndroid.request(
          PermissionsAndroid.PERMISSIONS.POST_NOTIFICATIONS
        );
        if (granted === PermissionsAndroid.RESULTS.GRANTED) {
          getFcmToken();
        } else {
        }
      } catch (e) {
        console.log("permission denied");
      }
    } else {
      const authStatus = await messaging().requestPermission();

      const enabled =
        authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
        authStatus === messaging.AuthorizationStatus.PROVISIONAL;

      if (enabled) {
        getFcmToken();
        console.log("Authorization status:", authStatus);
      }
    }
  };

  const getFcmToken = async () => {
    let fcmToken = await AsyncStorage.getItem("notifcationToken");
    if (!fcmToken) {
      try {
        if (Platform.OS === "ios") {
          await messaging().registerDeviceForRemoteMessages();
          await messaging().getAPNSToken();
        }

        fcmToken = await messaging().getToken();
        console.log(fcmToken);
        if (fcmToken) {
          await AsyncStorage.setItem("notifcationToken", fcmToken);
        }
      } catch (e) {}
    }
  };

  //Check Permissions for firebase messaging
  const checkPermission = async () => {
    const enabled = await messaging().hasPermission();
    if (enabled && enabled > 0) {
      getFcmToken();
    } else {
      setTimeout(() => {
        requestUserPermission();
      }, 500);
    }
    return enabled;
  };

  //Create Notification Listeners
  const createNotificationListeners = async () => {
    notificationBackgroundListener = messaging().setBackgroundMessageHandler(
      async (remoteMessage) => {
        console.log("Message handled in the background!", remoteMessage);
      }
    );
    // When the application is running, but in the background
    notificationListener = messaging().onNotificationOpenedApp(
      (remoteMessage) => {
        console.log(
          "[FCMService] onNotificationOpenedApp Notification caused app to open from background state:",
          remoteMessage
        );
        if (remoteMessage) {
          const { notification } = remoteMessage;
        }
      }
    );

    // When the application is opened from a quit state.
    messaging()
      .getInitialNotification()
      .then((remoteMessage) => {
        console.log(
          "[FCMService] getInitialNotification Notification caused app to open from quit state:",
          remoteMessage
        );

        if (remoteMessage) {
          const { notification } = remoteMessage;
        }
      });

    // Foreground state messages
    foregroundListener = messaging().onMessage(async (remoteMessage) => {
      await notifee.displayNotification({
        title: remoteMessage?.notification?.title,
        body: remoteMessage?.notification?.body,
        android: {
          channelId,
          //smallIcon: 'name-of-a-small-icon', // optional, defaults to 'ic_launcher'.
          // pressAction is needed if you want the notification to open the app when pressed
          pressAction: {
            id: "default",
          },
        },
      });
      if (remoteMessage) {
        let notification = null;
        if (Platform.OS === "ios") {
          notification = remoteMessage.data.notification;
        } else {
          notification = remoteMessage.notification;
        }
      }
    });
  };

  const configurePushnotification = () => {
    createChannel();
  };

  const createChannel = async () => {
    channelId = await notifee.createChannel({
      id: "default",
      name: "Tradex Notification Channel",
    });
  };

  useEffect(() => {
    if (!globalImport.isWeb) {
      checkPermission();
      if (initializeListener) {
        createNotificationListeners();
      }
      configurePushnotification();
      return removeListners;
    }
  }, []);
};

export default useNotification;
